import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailsComponent } from './details/details.component';
import { PaymentComponent } from './payment/payment.component';

const routes: Routes = [
  {
    path: 'details/:uuid',
    component: DetailsComponent,
  },
  {
    path: ':uuid',
    component: PaymentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
